/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.2-v202611051605-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * Returns a path to the specified item. Column type must be TEXT
 */
export interface ColumnRulePathInputV1 {
    /**
     * The index of the column with items to retrieve paths for. The column index is 1-based
     */
    "columnIndex": number;
    /**
     * Direction for counting levels: BOTTOM_UP (default, from leaf to root) or TOP_DOWN (from root to leaf). For path 'Plant >> Area >> Unit >> Sensor': BOTTOM_UP with level=1 returns 'Unit >> Sensor', TOP_DOWN with level=1 returns 'Plant >> Area'. When level exceeds path depth, the full available path is returned. Defaults to BOTTOM_UP if not specified.
     */
    "direction"?: DirectionEnum;
    /**
     * The number of additional hierarchy levels to include beyond the anchor point. For BOTTOM_UP, counts ancestors above the leaf item; for TOP_DOWN, counts descendants below the root. If not provided, all levels are included in the specified direction.
     */
    "level"?: number;
    /**
     * The separator between levels of the path. Defaults to ' >> '
     */
    "separator"?: string;
}

export const DirectionEnum = {
    BOTTOMUP: 'BOTTOM_UP',
    TOPDOWN: 'TOP_DOWN'
} as const;

export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];
